import { render } from "./CashierForm.vue?vue&type=template&id=10a870ae&ts=true"
import script from "./CashierForm.vue?vue&type=script&lang=ts"
export * from "./CashierForm.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/clickfun/frontend/clickfun_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__